import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query';
import env from '@beam-australia/react-env';

export const widgetBaseQuery = () => {
  return fetchBaseQuery({
    baseUrl: env('WIDGETS_BASE_URL')
  });
};
